import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactGA from 'react-ga4';
import { BASE_URL } from "../../api";
import { useNavigate } from "react-router-dom";
import Mobile from "../../components/Images/MobileIn.png";
import { useUserAuth } from "../UserAuthContext/UserAuthContext";
import "./Twilio.css";

const LoginPage = () => {
  const { handleLogin, handleLogout } = useUserAuth();
  const [mobile, setPhone] = useState("");
  const [code, setOTP] = useState("");
  const [message, setMessage] = useState("");
  const
   navigate = useNavigate();
  const [showOTPForm, setShowOTPForm] = useState(false);
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [isSending, setSending] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      handleLogout();
      navigate("/login");
    } else {
      // Check token expiration
      const decodedToken = decodeToken(token);
      const currentTime = Date.now() / 1000;
      if (decodedToken.exp < currentTime) {
        handleLogout();
        navigate("/login");
      }
    }
  }, [handleLogout, navigate]);

  const decodeToken = (token) => {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
          .join("")
      );

      return JSON.parse(jsonPayload);
    } catch (error) {
      console.log("Failed to decode token.", error);
      return null;
    }
  };

  const handleOTPInput = (e) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      // Limit input to six digits
      setOTP(e.target.value.slice(0, 6));
    }
  };

  const handleLoginM = async () => {
    ReactGA.event({
      category: 'Login With Mobile Number',
      action: 'Button Click',
      label: 'Send OTP'
    });

    if (!mobile) {
      setMessage("Please enter a mobile number.");
      return;
    }
    if (!/^[0-9]{10}$/.test(mobile)) {
      setMessage("Please enter a valid mobile number.");
      return;
    }

    try {
      setButtonDisabled(true);
      setSending(true);
      const response = await axios.post(`${BASE_URL}users/send_otp/`, {
        mobile: mobile,
        login_type: "mobile",
      });

      if (response.status) {
        setMessage("OTP code sent!");
        setShowOTPForm(true);
      } else {
        setMessage("Failed to send OTP code.");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSending(false);
      setButtonDisabled(false);
    }
  };

  const handleOTP = async () => {
    ReactGA.event({
      category: 'Login With Mobile Number',
      action: 'Button Click',
      label: 'verify OTP'
    });
    try {
      if (code.length !== 6) {
        setMessage("OTP should be exactly six digits.");
        return;
      }

      const response = await axios.post(`${BASE_URL}users/login/`, {
        login_type: "mobile",
        mobile: mobile,
        code: code,
      });

      // console.log("Response from server:", response.data);

      if (response.data.status_code === 200) {
        if (response.data.code === 1) {
          const token = response.data.data["token"];
          handleLogin(response.data.token);
          localStorage.setItem("token", token);
          setMessage("Logged in successfully!");
          navigate("/");
          setShowOTPForm(false);
        } else if (response.data.code === 0) {
          setMessage("Invalid OTP code.");
          setShowOTPForm(true);
        }
      } else {
        setMessage("Failed to verify OTP.");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="twiloLogin">
      <h4>Login with Mobile Number</h4>
      {!showOTPForm && (
        <>
          <div className="txt_fieldMobile">
            <input
              className="MobileInput MobileNumber"
              type="tel"
              name="mobileNumber"
              value={mobile}
              onChange={(e) => {
                const re = /^[0-9\b]+$/;
                if (e.target.value === "" || re.test(e.target.value)) {
                  setPhone(e.target.value);
                }
              }}
              minLength="10"
              maxLength="10"
              autoComplete="off"
              required
            />
            <span className="highlight"></span>
            <label className="labelMobile">Mobile number</label>
            <img className="phoneImg" src={Mobile} alt="" />
            <span className="countryCode"> +91</span>
          </div>
          <button
            className={`button-65 ${isButtonDisabled ? "disabled" : ""}`}
            onClick={handleLoginM}
            disabled={isButtonDisabled}
          >
            {isSending ? "Sending..." : "Send OTP"}
          </button>
        </>
      )}
      {showOTPForm && (
        <>
          <input
            minLength="6"
            maxLength="6"
            className="MobileInput OtpInput"
            type="tel"
            placeholder="Enter Otp"
            value={code}
            onChange={handleOTPInput}
          />
          <br />
          <br />
          <div className="Buttons-login-container">
            <button className="button-65" onClick={handleOTP}>
              Verify
            </button>
            <button
              className={`button-65 ${isButtonDisabled ? "disabled" : ""}`}
              onClick={handleLoginM}
              disabled={isButtonDisabled}
            >
              Resend Otp
            </button>
          </div>
        </>
      )}
      <br />
      <p>{message}</p>
    </div>
  );
};

export default LoginPage;
